import axios from 'axios'
import { environment } from '@/shared/consts/environment'

const selfUrl = `${environment.appUrl}/api`

/**
 * Returns geo user geolaction
 * @returns {
 *  {
 *    "country": "string",
 *    "city": "string",
 *  }
 * }
 * */
export const getGeoLocation = async () => {
  try {
    const res = await axios.post(`${selfUrl}/geo`)

    return res.data
  } catch (error) {
    if (environment.env === 'development') {
      console.error(error)
    }

    return null
  }
}
